import {
  Building2,
  Factory,
  Flame,
  ShieldCheck,
  HardHat,
  Leaf,
} from "lucide-react";

export const BACKEND_URL =
  typeof window !== "undefined" && window.location.hostname === "localhost"
    ? process.env.REACT_APP_BACKEND_URL
    : window.location.origin;
export const API = `${BACKEND_URL}/api`;
export const ADMIN_SESSION_KEY = "igel_admin_session";
export const CAROUSEL_INTERVAL_MS = 4000;
export const UNAUTHORIZED_STATUS = 401;

export const headerLogoUrl = "/favicon.svg";
export const footerLogoUrl =
  "https://customer-assets.emergentagent.com/job_09996496-0986-4aa8-9d86-7cdd8cb38d7d/artifacts/3lr2kepm_InfraGlobal%20Engineering%20%20Logo_page-0001.jpg";

export const createTranslator = () => (key, fallback) => fallback;

export const navLinks = [
  { key: "about", label: "About", href: "#about", testid: "nav-about-link" },
  { key: "services", label: "Services", href: "#services", testid: "nav-services-link" },
  { key: "sectors", label: "Sectors", href: "#sectors", testid: "nav-sectors-link" },
  { key: "projects", label: "Projects", href: "#projects", testid: "nav-projects-link" },
  { key: "credentials", label: "Credentials", href: "#credentials", testid: "nav-credentials-link" },
  { key: "clients", label: "Clients", href: "#clients", testid: "nav-clients-link" },
  { key: "governance", label: "Governance", href: "#governance", testid: "nav-governance-link" },
  { key: "careers", label: "Careers", href: "#careers", testid: "nav-careers-link" },
  { key: "contact", label: "Contact", href: "#contact", testid: "nav-contact-link" },
];

export const stats = [
  {
    value: "Governance-Driven",
    label: "EPC & O&M Organization",
    testid: "stat-years",
  },
  {
    value: "Multi-Sector",
    label: "Project Execution & Supply Capability",
    testid: "stat-projects",
  },
  {
    value: "Pan-India",
    label: "Operational Reach",
    testid: "stat-states",
  },
];

export const services = [
  {
    title: "Turnkey EPC Capabilities",
    description:
      "End-to-end engineering, procurement, and construction services structured to meet the requirements of public-sector, private-sector, and industrial infrastructure projects.",
    icon: Building2,
    testid: "service-epc",
  },
  {
    title: "Infrastructure Engineering Services",
    description:
      "Provision of civil,electrical, and mechanical engineering services aligned with urban, airport, rail, and industrial infrastructure requirements.",
    icon: Factory,
    testid: "service-infra",
  },
  {
    title: "Oil & Gas Facilities Capabilities",
    description:
      "Engineering and EPC services for process units, terminals, and pipeline stations in accordance with applicable PSU standards and guidelines.",
    icon: Flame,
    testid: "service-oil-gas",
  },
  {
    title: "Quality & Compliance Approach",
    description:
      "Internal quality and compliance procedures designed in line with recognized standards, including vendor evaluation and inspection coordination..",
    icon: ShieldCheck,
    testid: "service-quality",
  },
  {
    title: "Project Management Framework",
    description:
      "Defined project control, contractual coordination, and risk management processes aligned with institutional tender requirements.",
    icon: HardHat,
    testid: "service-pm",
  },
  {
    title: "Sustainability & ESG Approach",
    description:
      "Consideration of energy efficiency, water stewardship, and environmental, social, and governance principles within engineering and project planning activities.",
    icon: Leaf,
    testid: "service-sustainability",
  },
];

export const sectors = [
  {
    title: "Power & Energy Services",
    description:
      "Provision of engineering and technical support services for HT & LT works, solar, and energy efficiency initiatives.",
    testid: "sector-power",
  },
  {
    title: "Refineries & Petrochemicals Capabilities",
    description:
      "Provision of engineering and supply support services for process plants, storage installations, and pipeline systems in regulated environments.",
    testid: "sector-refineries",
  },
  {
    title: "Transport Infrastructure",
    description:
      "Provision of supply, installation, testing, and commissioning of electrification works for airports, metro stations, and transport terminals for public and private sector projects..",
    testid: "sector-transport",
  },
  {
    title: "Electrical, Mechanical & SHE Systems O&M",
    description:
      "O&M of electrical and mechanical assets including power distribution, HVAC, STP, and horticulture for infrastructure and building facilities.",
    testid: "sector-O & M",
  },
];

export const projects = [
  {
    title: "Electrical Installation & Substation Works",
    subtitle: "HV commissioning, switchyard integration, and power distribution",
    image:
      "https://customer-assets.emergentagent.com/job_09996496-0986-4aa8-9d86-7cdd8cb38d7d/artifacts/bcfbnja7_Electrical%20Substation.png",
    span: "md:col-span-8 lg:col-span-7",
    testid: "project-electrical",
  },
  {
    title: "Government Offices & Institutional Campuses",
    subtitle: "Turnkey civil works, MEP services, and campus development",
    image:
      "https://customer-assets.emergentagent.com/job_infra-engineering-1/artifacts/ewpitmqw_ChatGPT%20Image%20Feb%2010%2C%202026%2C%2002_34_27%20AM.png",
    span: "md:col-span-4 lg:col-span-5",
    testid: "project-campus",
  },
  {
    title: "Material Supply for Government & Private Clients",
    subtitle: "Warehousing, logistics, and just-in-time material deployment",
    image:
      "https://customer-assets.emergentagent.com/job_infra-engineering-1/artifacts/qq8khpx3_ELECTR_1.jpeg",
    span: "md:col-span-4 lg:col-span-5",
    testid: "project-supply",
  },
  {
    title: "Integrated Electrification and ECS Metro Stations",
    subtitle: "Internal & External Power Distribution, Lighting, and HVAC Systems",
    image:
      "https://customer-assets.emergentagent.com/job_infra-engineering-1/artifacts/9tgh3llc_89.png",
    span: "md:col-span-8 lg:col-span-7",
    testid: "project-metro",
  },
  {
    title: "Oil & Gas Pipeline Works",
    subtitle: "Cross-country pipeline installation, testing, and commissioning",
    image:
      "https://customer-assets.emergentagent.com/job_infra-engineering-1/artifacts/807dbr2b_ChatGPT%20Image%20Feb%2017%2C%202026%2C%2012_45_17%20AM.png",
    span: "md:col-span-12",
    testid: "project-pipeline",
  },
];

export const credentials = [
  { text: "MSME Udyam Registration" },
  { text: "GST Registration (Regular taxpayer)" },
  { text: "EPFO Registration" },
  { text: "ESIC Registration" },
  { text: "Incorporated under the Companies Act, 2013 as a Private Limited Company" },
  { text: "Internal procedures aligned with ISO 9001 / 14001 / 45001 principles" },
];

export const clients = [
  { label: "State Public Works Departments (PWDs)" },
  { label: "Central Public Works Departments (CPWD)" },
  { label: "Public Sector Undertakings (PSUs)" },
  { label: "Listed Private Companies" },
  { label: "IT & Technology Companies" },
  { label: "Industrial & Manufacturing Units" },
  { label: "Urban Local Bodies & Development Authorities" },
  { label: "Infrastructure Developers & EPC Companies" },
];

export const leadership = [
  {
    name: "Engineering & Project Governance",
    role: "Professional Oversight",
    bio: "Cross-functional leadership guiding EPC delivery, technical reviews, and on-ground execution governance.",
    icon: Building2,
    testid: "leader-governance",
  },
  {
    name: "Financial Stewardship Office",
    role: "Compliance & Risk",
    bio: "Ensures statutory compliance, fiscal controls, and transparent governance across EPC and supply engagements.",
    icon: ShieldCheck,
    testid: "leader-stewardship",
  },
];

export const careerRoles = [
  {
    title: "Project Execution",
    text: "Site engineers, supervisors, and QA/QC professionals for EPC delivery.",
    image:
      "https://images.unsplash.com/photo-1672954766589-49f0dd0e106f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHxjb25zdHJ1Y3Rpb24lMjBlbmdpbmVlcnMlMjBtZWV0aW5nJTIwc2l0ZSUyMGhlbG1ldHN8ZW58MHx8fHwxNzcwOTE2Njg1fDA&ixlib=rb-4.1.0&q=85",
    testid: "career-execution",
  },
  {
    title: "Design & Planning",
    text: "Design engineers, planners, and cost estimators for tender readiness.",
    image:
      "https://images.unsplash.com/photo-1568057373106-63057e421d1c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxlbmdpbmVlcmluZyUyMHBsYW5uaW5nJTIwYmx1ZXByaW50JTIwb2ZmaWNlJTIwdGVhbXxlbnwwfHx8fDE3NzA5MTY3MDF8MA&ixlib=rb-4.1.0&q=85",
    testid: "career-planning",
  },
  {
    title: "Supply & Procurement",
    text: "Procurement specialists and logistics coordinators for material supply.",
    image:
      "https://images.unsplash.com/photo-1740914994657-f1cdffdc418e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHx3YXJlaG91c2UlMjBsb2dpc3RpY3MlMjBpbnZlbnRvcnklMjBtYW5hZ2VtZW50fGVufDB8fHx8MTc3MDkxNjcxN3ww&ixlib=rb-4.1.0&q=85",
    testid: "career-supply",
  },
];
